/** Derive a short display name from a room ID */
export function deriveRoomDisplayName(roomId: string): string {
  const hash = roomId.slice(-4).toUpperCase();
  return `방 #${hash}`;
}
